var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountsReceivable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.52 40.8301H4.48C2.56 40.8301 1 39.2701 1 37.3401V16.6601C1 14.7401 2.56 13.1801 4.48 13.1801H47.51C49.43 13.1801 50.99 14.7401 50.99 16.6601V37.3501C51 39.2701 49.44 40.8301 47.52 40.8301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42 13.17V40.83H3.66L1.84 39.61L1 37.58V16.82L1.67 14.61L4.15 13.19L8.42 13.17Z",
    fill: "#FFCF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.52 40.8301H4.48C2.56 40.8301 1 39.2701 1 37.3401V16.6601C1 14.7401 2.56 13.1801 4.48 13.1801H47.51C49.43 13.1801 50.99 14.7401 50.99 16.6601V37.3501C51 39.2701 49.44 40.8301 47.52 40.8301Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6797 29.34C45.6597 29.1 45.5797 28.7701 45.4397 28.35C45.2997 27.93 45.0897 27.5801 44.8197 27.2801C44.5497 26.9801 44.1497 26.67 43.6197 26.35C43.0897 26.0301 42.4397 25.76 41.6897 25.56L41.0797 25.4V21.7801C41.3597 21.8601 41.6197 22.0201 41.8397 22.2801C42.1597 22.6601 42.3297 23.12 42.3497 23.65H45.2197C45.1397 22.33 44.6897 21.3201 43.8697 20.6201C43.1397 20.0001 42.2097 19.59 41.0897 19.41V17.8H40.6697H39.4797H39.0797V19.4C37.9297 19.54 36.9497 19.9501 36.1397 20.6101C35.2397 21.3501 34.7897 22.37 34.7897 23.68C34.7897 24.33 34.8997 24.8901 35.1097 25.3601C35.3297 25.8301 35.6497 26.22 36.0697 26.51C36.4897 26.8101 36.9097 27.04 37.3197 27.22C37.7297 27.4 38.2297 27.5601 38.8197 27.7001C38.9097 27.7201 38.9997 27.74 39.0697 27.76V32C38.5997 31.85 38.2097 31.59 37.8897 31.23C37.4897 30.77 37.2897 30.17 37.2997 29.4401H34.4297C34.7097 32.43 36.2597 34.08 39.0597 34.43V36.19H39.4597H40.6497H41.0697V34.43C41.6697 34.3601 42.2297 34.2301 42.7197 34.0401C43.3297 33.8001 43.8197 33.53 44.1697 33.21C44.5297 32.89 44.8297 32.54 45.0697 32.16C45.3097 31.78 45.4797 31.43 45.5597 31.1101C45.6497 30.7901 45.6897 30.51 45.6897 30.25C45.7097 29.89 45.6997 29.59 45.6797 29.34ZM38.0697 24.43C37.7897 24.1901 37.6597 23.84 37.6597 23.4C37.6597 22.86 37.8397 22.45 38.1997 22.16C38.4597 21.95 38.7497 21.82 39.0897 21.76V24.91C38.6197 24.79 38.2797 24.63 38.0697 24.43ZM42.1897 31.5201C41.8597 31.7701 41.4897 31.9501 41.0797 32.0401V28.35C41.6797 28.5301 42.1097 28.74 42.3697 28.96C42.6897 29.23 42.8397 29.62 42.8397 30.13C42.8397 30.72 42.6297 31.1901 42.1897 31.5201Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6201 18.5601H31.1001",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6201 23.53H20.6301",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41992 13.17V40.83",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6201 35.48H16.4901L20.9901 32.5L22.7401 34.69L25.9101 33.58L27.2401 35.48H31.1001",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsReceivable);
export default __webpack_public_path__ + "static/media/AccountsReceivable.da4caac0f80ce8b860674b8171d0891c.svg";
export { ForwardRef as ReactComponent };